var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c("div", { staticClass: "detail-card" }, [
      _c("div", { staticClass: "table-row" }, [
        _c("div", { staticClass: "table-header" }, [
          _vm._v(_vm._s(_vm.$t("Date")) + " | " + _vm._s(_vm.$t("Time"))),
        ]),
        _c("div", { staticClass: "table-cell" }, [
          _vm._v(_vm._s(_vm.ticketDate) + " | " + _vm._s(_vm.ticketTime)),
        ]),
      ]),
      _c("div", { staticClass: "table-row" }, [
        _c("div", { staticClass: "table-header" }, [
          _vm._v(_vm._s(_vm.$t("Game"))),
        ]),
        _c("div", { staticClass: "table-cell" }, [
          _vm._v(_vm._s(_vm.gameLabel)),
        ]),
      ]),
      _c("div", { staticClass: "table-row" }, [
        _c("div", { staticClass: "table-header" }, [
          _vm._v(_vm._s(_vm.$t("Ante"))),
        ]),
        _c("div", { staticClass: "table-cell" }, [
          _vm._v(
            " " + _vm._s(`${_vm.currencySymbol} ${_vm.ticket.taxAmount}`) + " "
          ),
        ]),
      ]),
      _vm.isMulti
        ? _c("div", { staticClass: "table-row" }, [
            _c("div", { staticClass: "table-header" }, [
              _vm._v(_vm._s(_vm.$t("Total bet"))),
            ]),
            _c("div", { staticClass: "table-cell bet" }, [
              _c("span", { staticClass: "bets-count" }, [
                _vm._v(
                  _vm._s(_vm.subTickets.length) + " " + _vm._s(_vm.$t("Bets"))
                ),
              ]),
              _c("span", { staticClass: "currency" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      `${_vm.currencySymbol} ${_vm.formatAmount(
                        _vm.ticket.amount
                      )}`
                    ) +
                    " "
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "table-row" }, [
            _c("div", { staticClass: "table-header" }, [
              _vm._v(_vm._s(_vm.$t("Bet"))),
            ]),
            _c(
              "div",
              { staticClass: "table-cell bet" },
              [
                _vm.ticket.selection === "banker"
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/svg/chart-icons/banker.svg"),
                        alt: "Banker count",
                      },
                    })
                  : _vm._e(),
                _vm.ticket.selection === "player"
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/svg/chart-icons/player.svg"),
                        alt: "Player count",
                      },
                    })
                  : _vm._e(),
                _vm.ticket.selection === "draw"
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/svg/chart-icons/draw.svg"),
                        alt: "Draw count",
                      },
                    })
                  : _vm._e(),
                _vm.iconMarket
                  ? _c("TxMarketBadge", { attrs: { market: _vm.iconMarket } })
                  : _vm.textMarket
                  ? _c(
                      "span",
                      {
                        staticClass: "market-badge",
                        class: _vm.textMarket.className,
                      },
                      [_vm._v(" " + _vm._s(_vm.textMarket.label) + " ")]
                    )
                  : _vm._e(),
                _c("span", { staticClass: "currency" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        `${_vm.currencySymbol} ${_vm.formatAmount(
                          _vm.ticket.amount
                        )}`
                      ) +
                      " "
                  ),
                ]),
              ],
              1
            ),
          ]),
      !_vm.isMulti
        ? _c("div", { staticClass: "table-row" }, [
            _c("div", { staticClass: "table-header" }, [
              _vm._v(_vm._s(_vm.$t("Odds"))),
            ]),
            _c("div", { staticClass: "table-cell" }, [
              _vm._v(_vm._s(_vm.oddsLabel)),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "table-row table-row--result" }, [
        _c("div", { staticClass: "table-header" }, [
          _vm._v(_vm._s(_vm.$t("Results"))),
        ]),
        _c(
          "div",
          { staticClass: "table-cell result-cell" },
          [
            _vm.resultDice
              ? [
                  _c("div", { staticClass: "dice-group-wrapper" }, [
                    _c(
                      "span",
                      { staticClass: "dice-group" },
                      _vm._l(_vm.resultDice, function (die, index) {
                        return _c("img", {
                          key: index,
                          staticClass: "dice-face",
                          attrs: {
                            src: _vm.diceImage(die),
                            alt: `Die ${index + 1}: ${die}`,
                          },
                        })
                      }),
                      0
                    ),
                    _c("span", { staticClass: "dice-total" }, [
                      _vm._v("= " + _vm._s(_vm.resultTotal)),
                    ]),
                  ]),
                  _c("div", { staticClass: "dice-total-wrapper" }, [
                    _c(
                      "span",
                      {
                        staticClass: "market-badge",
                        class: _vm.bigSmallBadgeClass,
                      },
                      [_vm._v(_vm._s(_vm.bigSmallLabel))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "market-badge",
                        class: _vm.oddEvenBadgeClass,
                      },
                      [_vm._v(_vm._s(_vm.oddEvenLabel))]
                    ),
                  ]),
                ]
              : _c(
                  "span",
                  {
                    staticClass: "result",
                    class: [
                      {
                        cancelled: _vm.ticket.result === "cancelled",
                        void: _vm.ticket.result === "void",
                        [_vm.fight.result]: [
                          _vm.FightStatus[12],
                          _vm.FightStatus[13],
                        ].includes(_vm.fight.status),
                      },
                    ],
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            _vm.$capitalize(
                              ["cancelled", "void"].includes(_vm.ticket.result)
                                ? _vm.ticket.result
                                : [
                                    _vm.FightStatus[12],
                                    _vm.FightStatus[13],
                                  ].includes(_vm.fight.status)
                                ? _vm.fight.result
                                : ""
                            )
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
          ],
          2
        ),
      ]),
      _vm.withCommission || _vm.hasCommission
        ? _c("div", { staticClass: "table-row" }, [
            _c("div", { staticClass: "table-header" }, [
              _vm._v(_vm._s(_vm.$t("Commission"))),
            ]),
            _c("div", { staticClass: "table-cell" }, [
              _vm._v(
                " " +
                  _vm._s(`${_vm.currencySymbol} ${_vm.ticket.commission}`) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm.isMulti
      ? _c(
          "div",
          { staticClass: "selections" },
          [
            _c("div", { staticClass: "selections__head" }, [
              _c("span", { staticClass: "selections__market" }, [
                _vm._v(_vm._s(_vm.$t("Selection"))),
              ]),
              _c("span", { staticClass: "selections__bet" }, [
                _vm._v(_vm._s(_vm.$t("Bet"))),
              ]),
              _c("span", { staticClass: "selections__odds" }, [
                _vm._v(_vm._s(_vm.$t("Odds"))),
              ]),
              _c("span", { staticClass: "selections__wl" }, [_vm._v("W / L")]),
            ]),
            _vm._l(_vm.subTickets, function (sub) {
              return _c(
                "div",
                {
                  key: sub.id,
                  staticClass: "selections__row",
                  class: { "is-win": _vm.subIsWin(sub) },
                },
                [
                  _c(
                    "span",
                    { staticClass: "selections__market" },
                    [
                      _vm.subIconMarket(sub)
                        ? _c("TxMarketBadge", {
                            attrs: { market: _vm.subIconMarket(sub) },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "market-badge",
                              class: _vm.subTextMarket(sub).className,
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.subTextMarket(sub).label) + " "
                              ),
                            ]
                          ),
                      _vm.subIsWin(sub)
                        ? _c("span", { staticClass: "selections__win" }, [
                            _vm._v(_vm._s(_vm.$t("Win"))),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "selections__bet" }, [
                    _vm._v(
                      _vm._s(
                        sub.derived ? "—" : _vm.formatBetAmount(sub.amount)
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "selections__odds" }, [
                    _vm._v(_vm._s(_vm.subOddsLabel(sub))),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "selections__wl",
                      class: _vm.subWlClass(sub),
                    },
                    [_vm._v(_vm._s(_vm.subWlText(sub)))]
                  ),
                ]
              )
            }),
          ],
          2
        )
      : _vm._e(),
    !_vm.showEarnings
      ? _c("div", { staticClass: "table-row table-row--footer" }, [
          _c("div", { staticClass: "table-header" }, [
            _vm._v(_vm._s(_vm.$t("Win/lose"))),
          ]),
          _c(
            "div",
            {
              staticClass: "table-cell",
              class: [
                {
                  win: !_vm.withCommission && _vm.ticket.winLossAmount > 0,
                  lose: !_vm.withCommission && _vm.ticket.winLossAmount < 0,
                },
              ],
            },
            [
              _vm._v(
                " " +
                  _vm._s(`${_vm.currencySymbol} ${_vm.ticket.winLossAmount}`) +
                  " "
              ),
            ]
          ),
        ])
      : _c("div", { staticClass: "table-row table-row--footer" }, [
          _c("div", { staticClass: "table-header" }, [
            _vm._v(_vm._s(_vm.$t("Earning"))),
          ]),
          _c(
            "div",
            {
              staticClass: "table-cell",
              class: [
                { win: _vm.ticket.earnings > 0, lose: _vm.ticket.earnings < 0 },
              ],
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    `${_vm.currencySymbol} ${_vm.formatAmountFixed(
                      _vm.ticket.earnings
                    )}`
                  ) +
                  " "
              ),
            ]
          ),
        ]),
    _vm.withCommission
      ? _c("div", { staticClass: "table-row table-row--footer" }, [
          _c("div", { staticClass: "table-header" }, [
            _vm._v(_vm._s(_vm.$t("Total"))),
          ]),
          _c(
            "div",
            {
              staticClass: "table-cell",
              class: [
                {
                  win:
                    Number(_vm.ticket.winLossAmount) +
                      Number(_vm.ticket.commission) >
                    0,
                  lose:
                    Number(_vm.ticket.winLossAmount) +
                      Number(_vm.ticket.commission) <
                    0,
                },
              ],
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    `${_vm.currencySymbol} ${
                      Number(_vm.ticket.winLossAmount) +
                      Number(_vm.ticket.commission)
                    }`
                  ) +
                  " "
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm.fight.replayUrl
      ? _c(
          "div",
          { staticClass: "bet-details-video-wrapper" },
          [
            _c("TCPlayer", {
              attrs: { height: "240", srcURL: _vm.fight.replayUrl },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }